import { ref } from 'vue';
import { authAPI, type UserData } from '../services/api';
import { getI18nT } from '../i18n';

const user = ref<UserData | null>(null);
const isLoading = ref(false);
const error = ref<string | null>(null);

export function useAuth() {
  const fetchUser = async (): Promise<UserData | null> => {
    const token = localStorage.getItem('token');
    if (!token) {
      user.value = null;
      return null;
    }

    isLoading.value = true;
    error.value = null;

    try {
      const userData = await authAPI.getMe();
      user.value = userData;
      return userData;
    } catch (err: any) {
      console.error('Error fetching user data:', err);

      // If 401, clear token and user data
      if (err.response?.status === 401) {
        localStorage.removeItem('token');
        user.value = null;
      }

      const t = getI18nT();
      error.value = err.response?.data?.message || t('composables.auth.error_fetch_user');
      return null;
    } finally {
      isLoading.value = false;
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    user.value = null;
    error.value = null;
  };

  return {
    user,
    isLoading,
    error,
    fetchUser,
    logout,
  };
}
